<template>
  <div v-if="$userInfo.isSupportUser"
    class="tile is-parent pl-1">
    <section class="tile is-child box">
      <div>
        <h3 class="subtitle mb-5">Sub Stages Setup</h3>
      </div>
      <div class="columns">
        <div class="column is-four-fifths">
          <div class="columns">
            <div class="column is-half">
              <span class="subtitle">Job Stage</span>
            </div>
            <div class="column is-half">
              <span class="subtitle">Sub Job Stage</span>
            </div>
          </div>
          <draggable :list="entitySummaries"
            group="entitySummaries"
            @change="() => updateSortKeys()"
            handle=".item-drag-handle">
            <div v-for="(stage, key) in entitySummaries"
              :key="key">
              <div class="pb-3">
                <ExpendableDiv
                  :ref="setExpendableDivRefs"
                  :title="stage.jobStageName"
                  :sub-title="stage.subJobStageName"
                  expended-title="Job Stage"
                  expended-sub-title="Sub Job Stage"
                  :enable-sort="true"
                  :style="{ 'border' : ((!stage.jobStage || !stage.subJobStageId) ?'1px solid #D92550':'') }">
                  <div class="columns">
                    <div class="column is-half">
                      <div class="control">
                        <div class="select is-fullwidth"
                          :class="{ 'is-danger' : !stage.jobStage}">
                          <select v-model="stage.jobStage"
                            @change="fetchSubJobStages(stage)">
                            <option v-for="item in jobStages"
                              :value="item.stage"
                              :key="item.stage">
                              {{ item.description }}
                            </option>
                          </select>
                          <span class="help is-danger"
                            v-if="!stage.jobStage">Field is required.</span>
                        </div>
                      </div>
                    </div>
                    <div class="column is-half">
                      <div class="control is-flex is-align-items-end is-flex-direction-column">
                        <div class="select is-fullwidth"
                          :class="{ 'is-danger' : !stage.subJobStageId}">
                          <select v-model="stage.subJobStageId">
                            <option v-for="item in stage.subJobStageOptions"
                              :value="item.subJobStageId"
                              :key="item.subJobStageId">
                              {{ item.subJobStageName }}
                            </option>
                          </select>
                        </div>
                        <div :class="{ 'is-flex is-justify-content-space-between is-align-items-center' : !stage.subJobStageId}"
                          :style="{ width: !stage.subJobStageId ? '100%' : '' }">
                          <span class="help is-danger"
                            v-if="!stage.subJobStageId">Field is required.</span>
                          <span class="icon has-text-danger"
                            @click="removeStage(key)">
                            <i class="mdi mdi-trash-can-outline mdi-20px" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ExpendableDiv>
              </div>
            </div>
          </draggable>
          <div class="button is-primary is-inverted is-fullwidth"
            style="border: 1px solid #e7e8eb; border-radius: 6px"
            @click="addStage">
            <span class="icon mr-3">
              <i class="mdi mdi-plus mdi-20px" />
            </span>
            Add New
          </div>
        </div>
        <div class="column is-one-fifths">
          <h3 class="subtitle">Available Sub Stages</h3>
          <div class="p-4 has-background-light mb-2"
            v-if="entitySummaries.length === 0"
            style="font-size: 0.9em">
            <div class="is-flex is-align-items-center">
              <div>
                <p>No Available Sub Stages.</p>
                <p>Click Add New to Set Up.</p>
              </div>
            </div>
          </div>
          <ul v-else>
            <li v-for="(subStages, jobStageName) in groupedStages"
              :key="jobStageName"
              class="has-background-light is-flex">
              <div>
                <span class="job-stage has-text-weight-bold">
                  {{ jobStageName }}
                </span>
                <ul class="pl-5">
                  <li v-for="name in subStages"
                    :key="name">- {{ name }}</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
  <div v-else
    class="is-flex is-justify-content-center pt-5">
    <div class="notification is-danger is-flex is-justify-content-center is-size-4"
      style="width: 50%">You do not have permissions on this page</div>
  </div>
</template>

<script>
import QuoteService from '../../quote/QuoteService'
import ExpendableDiv from '../components/ExpendableDiv'
import SubJobStageService from '../../subjobstage/SubJobStageService'
import CompanyService from '../../company/CompanyService'
import draggable from 'vuedraggable'
export default {
  name: 'SubJobStageSetup',

  components: {
    ExpendableDiv,
    draggable
  },

  data: () => {
    return {
      showSave: true,
      jobStages: [],
      subJobStages: [],
      entitySummaries: [],
      repxRepairStages: [],
      filter: {
        jobStageName: '',
        subJobStageName: '',
        sortColumn: 'sortKey',
        sortOrder: 'asc',
        pageIndex: 1,
        pageSize: 18
      }
    }
  },
  computed: {
    groupedStages() {
      const grouped = {}

      this.entitySummaries.forEach((stage) => {
        if (!stage.jobStageName) return
        if (!grouped[stage.jobStageName]) {
          grouped[stage.jobStageName] = []
        }
        grouped[stage.jobStageName].push(stage.subJobStageName || '(Unselected)')
      })
      return grouped
    },
    serilaizeData() {
      const serializedData = Object.entries(this.entitySummaries).map(([key, value]) => ({
        StageName: key,
        Stages: value
      }))
      return serializedData
    }
  },
  watch: {
    entitySummaries: {
      handler(val) {
        val.forEach((stage) => {
          this.$watch(
            () => stage.jobStage,
            () => {
              this.fetchSubJobStages(stage)
            },
            { immediate: true }
          )
        })
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    this.refresh()
  },
  mounted() {},
  methods: {
    async refresh() {
      await this.fetchJobStages()
      await this.fetchAllSubJobStages()
      await this.fetchRepxRepairStages()
      await this.getData()
      this.resetExpendableDivs()
    },
    async getData() {
      this.entitySummaries = await SubJobStageService.getSubJobStages(this.filter)
      this.entitySummaries.forEach((item, index) => {
        if (item.sortKey === null) {
          item.sortKey = index + 1
        }
      })
    },
    async fetchJobStages() {
      this.jobStages = await QuoteService.getJobStages()
    },
    async fetchAllSubJobStages() {
      this.subJobStages = await SubJobStageService.getAllActiveSubJobStage()
    },
    async fetchRepxRepairStages() {
      this.repxRepairStages = await CompanyService.getRepxStagesSetting()
    },
    async fetchSubJobStages(stage) {
      if (stage.jobStage) {
        const selectedIds = this.entitySummaries
          .filter((s) => s.subJobStageId !== stage.subJobStageId && s.jobStage === stage.jobStage)
          .map((s) => s.subJobStageId)
        const currentId = stage.subJobStageId
        stage.subJobStageOptions = this.subJobStages
          .filter((item) => item.jobStage == stage.jobStage && (item.subJobStageId === currentId || !selectedIds.includes(item.subJobStageId)))
          .sort((a, b) => a.sortKey - b.sortKey)

        const selected = stage.subJobStageOptions.find((s) => s.subJobStageId === currentId)
        stage.subJobStageName = selected ? selected.subJobStageName : ''
        if (!selected) {
          stage.subJobStageId = ''
        }

        const jobMatch = this.jobStages.find((j) => j.stage === stage.jobStage)
        stage.jobStageName = jobMatch ? jobMatch.description : ''
      } else {
        stage.subJobStageOptions = []
        stage.subJobStageId = ''
        stage.subJobStageName = ''
        stage.jobStageName = ''
      }
    },
    async addStage() {
      const newentity = await SubJobStageService.getNewEntity()
      this.entitySummaries.push(newentity)
      this.updateSortKeys()
    },
    removeStage(index) {
      const targetStage = this.entitySummaries[index]
      if (!targetStage.isNew) {
        const isMapped = this.repxRepairStages.some((stage, i) => i !== index && stage.subJobStageId === targetStage.subJobStageId)

        if (isMapped) {
          this.$toast.open({
            message: 'This Sub Stage is already used in RepX mapping.',
            type: 'is-danger',
            position: 'is-top',
            queue: false
          })
          return
        }
      }

      this.entitySummaries.splice(index, 1)
      this.updateSortKeys()
    },
    async save() {
      const unmapped = this.entitySummaries.some((stage) => !stage.jobStage || !stage.subJobStageId)
      if (unmapped) {
        this.$toast.open({
          message: 'Make sure all sub job stages are mapped',
          type: 'is-danger',
          position: 'is-top'
        })
        return false
      }

      try {
        this.$showSpinner()
        const result = await SubJobStageService.updateSubJobStagesSetup(this.entitySummaries)

        const { isSuccess, message } = result
        if (!isSuccess && message) {
          this.$toast.open({
            message: message,
            type: 'is-danger',
            position: 'is-top',
            queue: false
          })
          return
        }
        this.$toast.open({
          message: 'Sub Stages Setup Updated',
          type: 'is-success',
          position: 'is-top',
          queue: false
        })
        this.refresh()
        for (const stage of this.entitySummaries) {
          await this.fetchSubJobStages(stage)
        }
      } catch (error) {
        this.$toast.open({
          message: 'Failed Sub Stages Setup Updated',
          type: 'is-danger',
          position: 'is-top',
          queue: false
        })
      } finally {
        this.$hideSpinner()
      }
    },
    updateSortKeys() {
      this.entitySummaries.forEach((stage, index) => {
        stage.sortKey = index + 1
      })
    },
    setExpendableDivRefs(el) {
      if (!this.$refs.expendableDivRefs) {
        this.$refs.expendableDivRefs = []
      }
      if (el) {
        this.$refs.expendableDivRefs.push(el)
      }
    },
    resetExpendableDivs() {
      if (!this.$refs.expendableDivRefs) {
        return
      }
      (this.$refs.expendableDivRefs).forEach(i => {
        if (i.isExpanded)
          i.toggle()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.job-stage {
  display: block;
  width: 100%;
  padding: 0.5em;
  font-size: 0.9em;
}
.tile.is-vertical {
  margin-left: 1rem;
}
.tile.is-vertical > .tile.is-child:not(:last-child) {
  margin-bottom: 0.5rem !important;
}
.tile.is-ancestor.no-margin {
  padding-left: 0.5rem;
}
</style>
